import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { logError } from 'commons/logger';
import { useEffect } from 'react';

const DEFAULT_BASIC_DETAILS = {};

const useJbEventFBAddToCart = (basicDetails = DEFAULT_BASIC_DETAILS) => {
  useEffect(() => {
    window.jbEventFBAddToCart = () => {
      if (basicDetails?.sku) {
        sendFBEvent(FB_EVENTS.ADD_TO_CART, {
          content_category: basicDetails.productType,
          content_ids: [basicDetails.sku],
          content_name: basicDetails.productName,
          content_type: 'product',
          currency: 'USD',
          value: basicDetails.value,
        });
      } else {
        logError(new Error('window.jbEventFBAddToCart: missing sku'));
      }
    };
  }, [basicDetails]);
};

export default useJbEventFBAddToCart;
